import Vue from "vue";
import App from "@/App.vue";
import "@/redworks/plugins/vee-validate";  //검증 플러그인
import vuetify from "@/redworks/plugins/vuetify";
import router from "@/redworks/routes/index";
import store from "@/redworks/stores/index";
import i18n from "@/redworks/plugins/i18n";  //다국어 플러그인
import vueMoment from "vue-moment"; // 날짜 플러그인
import VueCryptojs from "vue-cryptojs"; //암호화 플러그인
import Notifications from 'vue-notification'; //알림용 플러그인
// 커스텀 제작 유틸 정의
import RxMessageBox from "@/redworks/js/utils/rx-message-box"; // 메시지박스 유틸
import RxCommonUtils from "@/redworks/js/utils/rx-common-utils"; // role체크 유틸
import "@/redworks/js/consts/rx-style-const"; //공통 스타일 상수 초기 등록
import "@/redworks/plugins/rx-base-component"; //베이스 콤포넌트 초기 등록
import VueDOMPurifyHTML from 'vue-dompurify-html';

Vue.config.productionTip = false;

Vue.use(VueCryptojs);
Vue.use(vueMoment);
Vue.mixin(RxMessageBox);
Vue.mixin(RxCommonUtils);
Vue.use(Notifications,{
  name:"rxNotify",
  componentName: "RxNotify"
});
Vue.use(VueDOMPurifyHTML);

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
